import React, { Component, useState } from 'react'
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';

export default class Tab extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeTab: 1
        }
        this.toggle = this.toggle.bind(this);
    }
    toggle(tab) {
        const { activeTab } = this.state;
        if (activeTab !== tab) this.setState({
            activeTab: tab
        });
    };
    render() {
        const { tabs, titles } = this.props;
        const { activeTab } = this.state;
        return(
        <div>
            <Nav tabs>
                {
                    titles.map((title, index) => {
                        return (
                            <NavItem key={index}>
                                <NavLink
                                    className={classnames({ active: activeTab == index + 1 })}
                                    onClick={() => { this.toggle(index + 1); }}
                                >
                                    {title}
                                </NavLink>
                            </NavItem>
                        )
                    })
                }
            </Nav>
            <TabContent activeTab={activeTab}>
                {
                    tabs.map((tab, index) => {
                        return(
                            <TabPane tabId={index + 1} key={index}>
                                {tab()}
                            </TabPane>
                        )
                    }) 
                }
            </TabContent>
        </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/Tab/Tab.js